import { FlexBox, FormField, Skeleton } from '@dixa/lib-shared-habla';

const InputFieldSkeleton = (): JSX.Element => {
  return (
    <FlexBox flexDirection="column" gap="200">
      <Skeleton height="16px" width="140px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
    </FlexBox>
  );
};

const ButtonSkeleton = (): JSX.Element => {
  return (
    <FlexBox flexDirection="column" gap="200">
      <Skeleton height="16px" width="140px" animation="wave" />
      <Skeleton height="40px" width="240px" animation="wave" />
    </FlexBox>
  );
};

export const OAuthProviderConfigurationModalLoading = (): JSX.Element => (
  <FormField>
    <FlexBox flexDirection="column" justifyContent="space-between" gap="400">
      <InputFieldSkeleton />
      <ButtonSkeleton />
      <ButtonSkeleton />
      <InputFieldSkeleton />
      <InputFieldSkeleton />
      <InputFieldSkeleton />
      <InputFieldSkeleton />
      <InputFieldSkeleton />
    </FlexBox>
  </FormField>
);
